import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SelectionList from '@justgiving/selection-list';

import { paths } from '../../constants';

export class AddressSearchResults extends Component {
  static propTypes = {
    findAddressResults: PropTypes.shape({
      data: PropTypes.array,
      status: PropTypes.shape({
        isFetching: PropTypes.bool.isRequired,
        error: PropTypes.bool.isRequired,
      }),
    }),
    history: PropTypes.shape({
      push: PropTypes.func,
    }),
  };

  static defaultProps = {
    findAddressResults: undefined,
  };

  constructor() {
    super();
    this.onChange = this.onChange.bind(this);
  }

  onChange(address) {
    const {
      AddressLine1,
      AddressLine2,
      Town,
      City,
      State,
      PostCode,
      Country,
    } = address;
    this.props.history.push(
      `${paths.Address}?AddressLine1=${AddressLine1}&AddressLine2=${AddressLine2}&Town=${Town}&City=${City}&State=${State}&PostCode=${PostCode}&Country=${Country}`,
    );
  }

  render() {
    const { findAddressResults } = this.props;
    if (
      findAddressResults !== undefined &&
      findAddressResults.data !== undefined &&
      findAddressResults.data.length > 0
    ) {
      const items = findAddressResults.data.map(address => {
        const label = `${address.AddressLine1} ${address.AddressLine2}, ${address.Town},\n ${address.County}, ${address.PostCode}`;
        return { label, value: address };
      });

      return (
        <>
          <h1>Select your Address</h1>
          <SelectionList items={items} onChange={this.onChange} />
        </>
      );
    }
    return <>No addresses found for post code</>;
  }
}

export default AddressSearchResults;
